export enum ForgotPasswordStates {
    Default = 'DEFAULT',
    EmailSent = 'EMAIL_SENT'
}
